"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.step.progress': 'Krok {current} z {total}',
};
